import { Linking } from 'react-native'
import { logger } from '../logging/logger'

const CONTACT_US_URL =
  'https://intercom.help/funxyz/en/articles/10732578-contact-us'

export function openKycSupport() {
  void Linking.openURL(CONTACT_US_URL).catch(() => {
    logger.warn('connect-rn:fiat:kyc_support_not_opened')
  })
}
